import React, { useCallback } from 'react';
import classnames from 'classnames';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';

import Filter from './filter';

import styles from '../styles/filters.module.scss';

const Filters = ({
  dropdownPosition,
  filters,
  hasLeftHandle,
  hasRightHandle,
  isLoading,
  isLoadingContent,
  onClearButtonClick,
  onDropdownToggle,
  onHandleClick,
  onScroll,
  onScrollerUpdate,
  onSelectionUpdate,
  selection,
}) => {
  if (isLoading) return <Loading className={styles.loader} />;

  if (!filters.length) return;

  const ref = useCallback((scroller) => {
    const observer = new ResizeObserver((entries) => (
      onScrollerUpdate(entries[0].target)
    ));

    observer.observe(scroller);
  }, []);

  return (
    <div className={styles.element}>
      <div
        className={classnames(styles.scrollerContainer, {
          [styles.hasLeftHandle]: hasLeftHandle,
          [styles.hasRightHandle]: hasRightHandle,
        })}
      >
        <div className={styles.scroller} onScroll={onScroll} ref={ref}>
          {filters.map(({ query_param: param, ...filter }) => (
            <Filter
              dropdownPosition={dropdownPosition}
              isLoading={isLoadingContent}
              key={filter.id}
              name={filter.display_name}
              onDropdownToggle={onDropdownToggle}
              onSelectionUpdate={onSelectionUpdate}
              options={filter.options}
              param={param}
              selection={selection[param] || []}
              shouldAllItemsBeSelectable={filter.should_all_items_be_selectable}
            />
          ))}
        </div>
        <div className={classnames(styles.handleContainer, styles.isLeft)}>
          <Button
            className={styles.handle}
            icon={<KeyboardArrowLeft />}
            onClick={() => onHandleClick('left')}
            variant="ghost"
          />
        </div>
        <div className={classnames(styles.handleContainer, styles.isRight)}>
          <Button
            className={styles.handle}
            icon={<KeyboardArrowRight />}
            onClick={() => onHandleClick('right')}
            variant="ghost"
          />
        </div>
      </div>
      <Button
        className={styles.clear}
        isDisabled={!Object.values(selection).some(({ length }) => length)}
        onClick={onClearButtonClick}
        size="xsmall"
        text={i18n.t('clear-filters')}
        variant="text"
      />
    </div>
  );
};

export default React.memo(Filters);
